import wx from "weixin-js-sdk";
import axiosInstance from "@/axios/axiosInstance";

export const setupWechatShare = async ({
  title = "渐风AI",
  desc = "渐风AI是一个专业的人工智能学习平台",
  imgUrl = "https://www.aijfeng.com/share-logo.jpg",
  customUrl = null,
}) => {
  try {
    const currentUrl = customUrl || window.location.href.split("#")[0];
    const response = await axiosInstance.get(
      `/account/wxlogin?url=${encodeURIComponent(currentUrl)}`
    );
    const config = response.data.data;

    wx.config({
      debug: false,
      appId: config.appId,
      timestamp: config.timestamp,
      nonceStr: config.nonceStr,
      signature: config.signature,
      jsApiList: [
        "updateAppMessageShareData",
        "updateTimelineShareData",
        "onMenuShareTimeline",
        "onMenuShareAppMessage",
      ],
    });

    const shareData = {
      title,
      desc,
      link: currentUrl,
      imgUrl,
      success: function () {
        console.log("分享设置成功");
      },
      fail: function (res) {
        console.error("分享设置失败:", res);
      },
    };

    wx.ready(() => {
      // 新版接口
      wx.updateAppMessageShareData(shareData);
      wx.updateTimelineShareData(shareData);

      // 旧版接口兼容
      wx.onMenuShareAppMessage({
        ...shareData,
        type: "link",
      });
      wx.onMenuShareTimeline({
        title: shareData.title,
        link: shareData.link,
        imgUrl: shareData.imgUrl,
      });
    });

    wx.error((res) => {
      console.error("微信配置失败:", res);
    });

    return currentUrl;
  } catch (error) {
    console.error("获取微信配置失败:", error);
    throw error;
  }
};

// 更新页面的 meta 标签
export const updateMetaTags = (title, description) => {
  // 更新文档标题
  document.title = `${title} - 渐风AI`;

  // 更新 meta 标签
  const metaTags = {
    "og:title": title,
    "og:description": description || "渐风AI是一个专业的人工智能学习平台",
    "og:url": window.location.href,
  };

  Object.entries(metaTags).forEach(([property, content]) => {
    let meta = document.querySelector(`meta[property="${property}"]`);
    if (!meta) {
      meta = document.createElement("meta");
      meta.setAttribute("property", property);
      document.head.appendChild(meta);
    }
    meta.setAttribute("content", content);
  });
};
